import { RG_TYPE as e } from "@project-rouge/rg-core";
import { getArea as n } from "../index3.js";
import { getCountOfType as o } from "../../counting/index.js";
const f = (t) => {
  const r = n(t);
  return r === 0 ? 0 : o(t, e.Apartment) / r;
};
export {
  f as getDensityUnits
};
//# sourceMappingURL=index15.js.map
